export const AUTH_TOKEN_KEY = 'access-token'
export const ID_TOKEN_KEY = 'id-token'
export const REFRESH_TOKEN_KEY = 'refresh-token'
export const EXPIRE_TIME_KEY = 'expire-time'
export const LOGIN_ID_KEY = 'login-id'
export const TOKEN_EXPIRATION_TIME = 60 * 30
export const ID_TOKEN_EXPIRATION_TIME = 60 * 60
export const REFRESH_TOKEN_EXPIRATION_TIME = 60 * 60
export const DEFAULT_PAGE_ROWS = 10
export const seconds = 60
export const ACCESS_TOKEN_LIFE_SPAN_EXPIRE_TIME = 601

type Permission = {
  name: string
  action: string
}

export enum ROLE {
  SUPER_ADMIN = 'SUPER_ADMIN',
  DIVISION_ADMIN = 'DIVISION_ADMIN',
  SYSTEM_USER = 'SYSTEM_USER',
  END_USER = 'END_USER',
}

export type Role = {
  type: ROLE
  name: string
  permissions: Permission[]
}

type Authenticator = {
  name: string
  type: string
}

export const ROLE_PERMISSIONS: Role[] = [
  {
    type: ROLE.SUPER_ADMIN,
    name: 'label.superAdmin',
    permissions: [
      {
        name: 'division',
        action: 'index',
      },
      {
        name: 'division',
        action: 'create',
      },
      {
        name: 'division',
        action: 'edit',
      },
      {
        name: 'division',
        action: 'delete',
      },
      {
        name: 'project',
        action: 'index',
      },
      {
        name: 'project',
        action: 'create',
      },
      {
        name: 'project',
        action: 'edit',
      },
      {
        name: 'project',
        action: 'delete',
      },
      {
        name: 'application',
        action: 'index',
      },
      {
        name: 'application',
        action: 'create',
      },
      {
        name: 'application',
        action: 'edit',
      },
      {
        name: 'application',
        action: 'delete',
      },
      {
        name: 'client',
        action: 'index',
      },
      {
        name: 'client',
        action: 'create',
      },
      {
        name: 'client',
        action: 'edit',
      },
      {
        name: 'client',
        action: 'delete',
      },
      {
        name: 'user',
        action: 'index',
      },
      {
        name: 'user',
        action: 'create',
      },
      {
        name: 'user',
        action: 'edit',
      },
      {
        name: 'user',
        action: 'delete',
      },
      {
        name: 'setting',
        action: 'index',
      },
      {
        name: 'setting',
        action: 'edit',
      },
      {
        name: 'end-user',
        action: 'index',
      },
      {
        name: 'end-user',
        action: 'create',
      },
      {
        name: 'end-user',
        action: 'edit',
      },
      {
        name: 'end-user',
        action: 'delete',
      },
    ],
  },
  {
    type: ROLE.DIVISION_ADMIN,
    name: 'label.divisionAdmin',
    permissions: [
      {
        name: 'division',
        action: 'index',
      },
      {
        name: 'project',
        action: 'index',
      },
      {
        name: 'project',
        action: 'create',
      },
      {
        name: 'project',
        action: 'edit',
      },
      {
        name: 'project',
        action: 'delete',
      },
      {
        name: 'application',
        action: 'index',
      },
      {
        name: 'application',
        action: 'create',
      },
      {
        name: 'application',
        action: 'edit',
      },
      {
        name: 'application',
        action: 'delete',
      },
      {
        name: 'client',
        action: 'index',
      },
      {
        name: 'client',
        action: 'create',
      },
      {
        name: 'client',
        action: 'edit',
      },
      {
        name: 'client',
        action: 'delete',
      },
      {
        name: 'user',
        action: 'index',
      },
      {
        name: 'user',
        action: 'create',
      },
      {
        name: 'user',
        action: 'edit',
      },
      {
        name: 'user',
        action: 'delete',
      },
      {
        name: 'end-user',
        action: 'index',
      },
      {
        name: 'end-user',
        action: 'create',
      },
      {
        name: 'end-user',
        action: 'edit',
      },
      {
        name: 'end-user',
        action: 'delete',
      },
    ],
  },
  {
    type: ROLE.SYSTEM_USER,
    name: 'label.systemUser',
    permissions: [
      {
        name: 'application',
        action: 'index',
      },
      {
        name: 'application',
        action: 'create',
      },
      {
        name: 'application',
        action: 'edit',
      },
      {
        name: 'application',
        action: 'delete',
      },
      {
        name: 'client',
        action: 'index',
      },
      {
        name: 'client',
        action: 'create',
      },
      {
        name: 'client',
        action: 'edit',
      },
      {
        name: 'client',
        action: 'delete',
      },
      {
        name: 'end-user',
        action: 'index',
      },
      {
        name: 'end-user',
        action: 'create',
      },
      {
        name: 'end-user',
        action: 'edit',
      },
      {
        name: 'end-user',
        action: 'delete',
      },
    ],
  },
  {
    type: ROLE.END_USER,
    name: 'label.endUser',
    permissions: [],
  },
]

export const AUTHEN_TYPE = {
  authorization: 'Authorization Flow',
  authorization_pkce: 'Authorization PKCE Flow',
  client_credentials: 'Client Credentials Flow',
  user_credentials: 'User Credentials Flow',
}

export const AUTHENTICATOR_TYPES: Authenticator[] = [
  {
    name: 'Authorization Flow',
    type: 'authorization',
  },
  {
    name: 'Authorization PKCE Flow',
    type: 'authorization_pkce',
  },
  {
    name: 'Implicit Flow',
    type: 'implicit',
  },
  {
    name: 'Client Credentials Flow',
    type: 'client_credentials',
  },
  {
    name: 'User Credentials Flow',
    type: 'user_credentials',
  },
]

export const PASSWORD_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$\'%^&*()_+\-=[\]{}|])[A-Za-z\d!@#$\'%^&*()_+\-=[\]{}|]{14,}$/
export const REDIRECT_URL_REGEX =
  /^https?:\/\/([-a-z0-9@:%._+~#=]{1,256}\.[a-z0-9]{1,6}|localhost[:?\d]*)\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/
export const HTTPS_URL_REGEX = /^https:\/\/(www\.)?[-a-z0-9@:%._+~#=]{1,256}\.[a-z0-9()]{1,6}$/
export const HTTPS_IP_ADDRESS_REGEX =
  /^https:\/\/(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/

export enum AUTHENTICATOR_TYPE {
  AUTHORIZATION = 'authorization',
  AUTHORIZATION_PKCE = 'authorization_pkce',
  IMPLICIT = 'implicit',
  CLIENT_CREDENTIALS = 'client_credentials',
  USER_CREDENTIALS = 'user_credentials',
  AUTHORIZATION_CODE = 'authorization_code',
}

export enum ERROR_CODES {
  PROJECT_ALREADY_HAS_AN_APPLICATION = 1001,
  PROJECT_ALREADY_HAS_A_USER = 1002,
  PROJECT_ALREADY_EXISTS = 1003,
  CREDENTIAL_EMPTY = 1008,
  RESET_TOKEN_EXPIRE = 1009,
  APPLICATION_ALREADY_HAS_CLIENT = 2002,
  APPLICATION_ALREADY_HAS_USER = 2003,
  APPLICATION_CANT_UPDATE_CLIENT_CREDENTIALS_TYPE = 2005,
}
